import { useState, useEffect } from "react";
import axios, { AxiosError } from "axios";

/**
 * Axios interceptor component to handle request and response interception.
 * @param children - The child components to render once interceptors are set up.
 * @returns The child components if interceptors are set up, otherwise undefined.
 */
export const AxiosInterceptor = ({ children }: { children: React.ReactNode }) => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const requestInterceptor = axios.interceptors.request.use((request) => {
            // Clean up the Graph QL query, if one exists for the request, by removing extra spaces and new lines.
            if (request.data && request.data.query) {
                request.data.query = request.data.query.replace(/\s+/g, " ").trim();
            }

            if (request.headers) {
                request.headers["Accept"] = "application/json";
                request.headers["Content-Type"] = "application/json";
            }

            return request;
        });

        const responseInterceptor = axios.interceptors.response.use(
            (response) => {
                return response;
            },
            (error: AxiosError) => {
                console.warn(error);
            },
        );

        setIsLoaded(true);

        return () => {
            axios.interceptors.request.eject(requestInterceptor);
            axios.interceptors.response.eject(responseInterceptor);
        };
    }, []);

    return isLoaded ? children : undefined;
};
